import './base-styles/components/_component.input.scss';

import './base-styles/libs/index.css';
import './base-styles/index.scss';
import 'virtual:vite-svg-2-webfont.css';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import Alpine from 'alpinejs';

import { registerAlpinePlugins } from './alpine-plugins';
import { registerFormBuilder } from './plugins/form-builder';

registerFormBuilder();
registerAlpinePlugins();
window.Alpine = Alpine;
Alpine.start();
